module.exports = "<div class=\"status_cont\" [@fadeInUp]>\r\n    <ul class=\"onb-list-group status\">\r\n        <li *ngFor=\"let stage of stages; let i = index;\" class=\"onb-list-group-item\" [class.current]=\"stage.id == currentStageId\" [class.incomp]=\"stage.id != currentStageId\" id=\"stage-{{stage.id}}\" title=\"{{stage.name}}\">\r\n            <i class=\"{{stage.statusIcon}}\"></i>\r\n        </li>\r\n    </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/sidebar/sidebar.component.html
// module id = ./src/app/shared/components/sidebar/sidebar.component.html
// module chunks = main